var render, staticRenderFns
import script from "./TileBase.vue?vue&type=script&lang=js"
export * from "./TileBase.vue?vue&type=script&lang=js"
import style0 from "./TileBase.vue?vue&type=style&index=0&id=2fcf9d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcf9d14",
  null
  
)

export default component.exports